<nav class="navbar-dark bg-dark fixed-bottom">
  <span class="navbar-text">
    &nbsp; {{version}} (Server: {{serverVersion}} - <span
      [ngClass]="connectionState.class">{{connectionState.label}}</span>)
  </span>&nbsp;
  <span class="pull-right mr-4 mt-2 text-success" [ngClass]="{'text-danger': loading}" *ngIf="dev">{{appState}} progress bar?</span>
</nav>
